import {ApplicationRef, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {CommunicationService} from '../../../service/communication.service';
import {DialogViewModelCreatorService} from '../../../service/dialog-view-model-creator.service';
import {BotatoChatManagerService} from '../../../service/botato-chat-manager.service';
import {Subscription} from 'rxjs';
import {InputComponent} from '../input.component';
import {InputDataService} from '../../input-data.service';
import {
    DialogConfigInputOptionsAutocompleteInput, DialogConfigInputType
} from 'botato-botengine-browser/botato/botato-botengine/source/Core/DialogConfig/DialogConfig.js';
import {
    InputSourceType
} from 'botato-botengine-browser/botato/botato-botengine/source/InstantMessagingAdapter/WebSocket/dto/InputSourceType.js';

@Component({
    templateUrl: './autocomplete-input.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AutocompleteInputComponent extends InputComponent<DialogConfigInputOptionsAutocompleteInput> implements OnInit, OnDestroy {

    public static TYPE: DialogConfigInputType = 'autocomplete';
    public isConnected: boolean | undefined;
    public displayOverlay: boolean = false;
    public userText: string = '';
    public values: string[] = [];
    public inputOptionsComponent: DialogConfigInputOptionsAutocompleteInput | undefined;
    @ViewChild('messageInput', {static: true})
    private messageInput!: ElementRef;
    private subscription = new Subscription();

    constructor(private communicationService: CommunicationService,
                public dialogViewModelCreator: DialogViewModelCreatorService,
                private chatManagerService: BotatoChatManagerService,
                private applicationRef: ApplicationRef,
                private inputDataService: InputDataService,
                private changeDetectorRef: ChangeDetectorRef) {
        super();

        Object.defineProperty(this, 'inputOptions', {
            set(inputOptions: DialogConfigInputOptionsAutocompleteInput): void {

                this.inputOptionsComponent = inputOptions;

                if (this.inputOptionsComponent?.dataKey !== undefined) {

                    this.getDataList();
                }
            },
        });
    }

    public ngOnInit(): void {
        this.getDataList();

        this.subscription.add(this.chatManagerService.focusInput$.subscribe(() => this.messageInput.nativeElement.focus()));
        this.subscription.add(this.communicationService.connectionStateChanged.subscribe((state: boolean) => {
            this.isConnected = state;
            this.changeDetectorRef.markForCheck();
        }));
    }

    public validateText(text: string): boolean {
        console.log('this.inputOptions', this.inputOptions);

        const validation = this.inputOptionsComponent?.validation;
        if (validation === undefined) {
            throw new Error('The autocomplete input options do not define a validation');
        }
        const regularExpression = new RegExp(validation.regex);
        return regularExpression.test(text);
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public onEnterPressed(event: KeyboardEvent): void {
        if (event.keyCode === 13 || event.key === 'Enter') {
            event.preventDefault();

            // It can happen that the keyDown Event of the Enter-key does happen before the keyUp-event of the last
            // key the user typed before hitting the enter button. In this case the binding did not yet refresh
            // the userText and we send an incomplete message. To fix this we add additional 100ms to make sure
            // the event of the last keystroke happened.
            setTimeout(async () => {
                if (this.canSendMessage()) {
                    await this.sendUserText();
                }
            }, 100);
        }
        this.applicationRef.tick();
    }

    public onKeyUp(): void {
        this.inputDataService.setSearchQuery(this.dataKey, this.userText);
    }

    private get dataKey(): string {
        const dataKey = this.inputOptionsComponent?.dataKey;
        if (dataKey === undefined) {
            throw new Error('The autocomplete input options do not define a dataKey');
        }
        return dataKey;
    }

    public async sendUserText(): Promise<void> {
        await this.sendMessage(this.userText, 'autocomplete');
    }

    public canSendMessage(): boolean {
        return this.userText !== undefined && this.userText.trim().length !== 0 && this.isConnected !== true;
    }

    public onFocusIn(): void {
        this.displayOverlay = true;
        this.applicationRef.tick();
    }

    public async sendMessage(text: string, inputSource: InputSourceType): Promise<void> {
        this.displayOverlay = true;
        this.dialogViewModelCreator.addUserTextMessage(text);
        await this.communicationService.sendMessage(text, inputSource);
        this.userText = '';
        this.changeDetectorRef.markForCheck();
        this.applicationRef.tick();
    }

    public closeAutocompleteOverlay(): void {
        this.displayOverlay = false;
        this.applicationRef.tick();
    }

    private getDataList(): void {
        this.inputDataService.getDataList(this.dataKey).subscribe((values) => {
            this.values = values;
            // markForCheck is safe both inside and outside a running tick, unlike the tick() it replaces
            this.changeDetectorRef.markForCheck();
        });
    }

}
